<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center">
      <div class="w-50-porcento pr-2">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          multiple
          hide-details
          auto_selecao_primeiro_grupo
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filial"
          label="Filial"
          outlined
          multiple
          hide-details
        />
      </div>
    </div>

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import $axios from "@/api/api";

export default {
  name: "Exemplo",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete
  },
  data: () => ({
    filtros: {
      grupos: [],
      filial: [],
      fornecedores: [],
    }
  }),
  methods: {
    gerarRelatorio() {
      const form = document.createElement('form');

      form.setAttribute('action', $axios.defaults.baseURL + `/${this.relatorio.url}`);
      form.setAttribute('method', 'POST');
      form.setAttribute('target', '_blank');
      form.setAttribute('style', 'display: none;');

      const filtros = { ...this.filtros };

      const array_filtros = ['fornecedores'];
      array_filtros.forEach(item => this.Helpers.adicionarInputsFiltros(form, filtros, item));

      Object.keys(filtros).forEach(key => {
        const valor = Array.isArray(filtros[key]) ? filtros[key] : [filtros[key]];

        valor.forEach(item => {
          const input = document.createElement('input');
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', `${key}[]`);
          input.setAttribute('value', item);
          form.appendChild(input);
        });
      });

      document.body.appendChild(form);
      form.submit();

      form.remove();

      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
